import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useState, useEffect } from 'react';
import getEnv from '../utils/getEnv';
export var useOnPremiseNetworkStatus = function useOnPremiseNetworkStatus() {
  var _useState = useState(typeof navigator !== 'undefined' ? navigator.onLine : true),
    isOnline = _useState[0],
    setIsOnline = _useState[1];
  useEffect(function () {
    var checkInterval;
    var lastCheck = 0;
    var mounted = true;
    var MIN_CHECK_GAP = 10000;
    var ACTIVE_CHECK_INTERVAL = 30000;
    var API_TIMEOUT = 3000;

    // Use Google by default, allow override via env variable

    var checkConnectivity = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var now, controller, timeoutId, CONNECTIVITY_CHECK_URL, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (mounted) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              now = Date.now();
              if (!(now - lastCheck < MIN_CHECK_GAP)) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              lastCheck = now;
              _context.p = 3;
              controller = new AbortController();
              timeoutId = setTimeout(function () {
                return controller.abort();
              }, API_TIMEOUT); // Check external URL for real internet connectivity
              CONNECTIVITY_CHECK_URL = getEnv('NEXT_PUBLIC_CONNECTIVITY_CHECK_URL') || 'https://www.google.com/generate_204';
              _context.n = 4;
              return fetch(CONNECTIVITY_CHECK_URL, {
                method: 'HEAD',
                mode: 'no-cors',
                cache: 'no-store',
                signal: controller.signal
              });
            case 4:
              response = _context.v;
              clearTimeout(timeoutId);

              // With no-cors, we can't read response status, but fetch will succeed if reachable
              if (mounted) {
                setIsOnline(true);
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              if (mounted) {
                // Any error means we couldn't reach the external URL
                setIsOnline(false);
                console.warn('[NetworkStatus] Connectivity check failed:', _t);
              }
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[3, 5]]);
      }));
      return function checkConnectivity() {
        return _ref.apply(this, arguments);
      };
    }();
    var startActiveChecking = function startActiveChecking() {
      // Always clear any existing interval first to prevent memory leaks
      stopActiveChecking();
      if (!document.hidden && mounted) {
        checkInterval = setInterval(function () {
          if (!document.hidden && mounted) {
            checkConnectivity();
          }
        }, ACTIVE_CHECK_INTERVAL);
      }
    };
    var stopActiveChecking = function stopActiveChecking() {
      if (checkInterval) {
        clearInterval(checkInterval);
        checkInterval = undefined;
      }
    };
    var handleVisibilityChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (document.hidden) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return checkConnectivity();
            case 1:
              startActiveChecking();
              _context2.n = 3;
              break;
            case 2:
              stopActiveChecking();
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleVisibilityChange() {
        return _ref2.apply(this, arguments);
      };
    }();
    document.addEventListener('visibilitychange', handleVisibilityChange);
    checkConnectivity();
    startActiveChecking();
    return function () {
      mounted = false;
      stopActiveChecking();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return isOnline;
};
export default useOnPremiseNetworkStatus;